import { IconName, Tag } from "@blueprintjs/core";
import * as React from "react";

import { IViewProps, View } from "core/decorators/View";
import styled from "styled-components";
import { TagViewConfig } from "./TagViewConfig";
import { toBlockCss } from "../common/TagStylesConfig";

export interface ITagViewProps<T> extends IViewProps<TagViewConfig> {
		fill?: boolean;
		icon?: IconName | JSX.Element;
		value?: T;
		onRemove?: (value: T) => void;
}

interface ITagProps {
	config: TagViewConfig;
	fill?: boolean;
}

const StyledTag = styled(Tag)<ITagProps>(({config}) => [toBlockCss(config.defaultState)]);

@View({id: "tag", configClass: TagViewConfig})
export class TagView<T = any> extends React.PureComponent<ITagViewProps<T>> {

	public render() {
		const { config, fill, icon, onRemove, style } = this.props;

		return (
			<StyledTag
				config={config}
				icon={icon}
				fill={fill}
				minimal={config.minimal}
				round={config.round}
				large={config.large}
				onRemove={typeof onRemove === 'function' ? this.onRemove : undefined}
				style={style}
			>
				{this.props.children}
			</StyledTag>
		);
	}

	private onRemove = () => {
		this.props.onRemove(this.props.value);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/tag/TagView.view.tsx